import { Color } from "../../Domain/Model/Color";
import { ColorRepository } from "../../Domain/Repository/ColorRepository";
import ColorDataSource from "../DataSource/ColorDataSource";

export class ColorRepositoryImpl implements ColorRepository {
  dataSource: ColorDataSource;

  constructor(_datasource: ColorDataSource) {
    this.dataSource = _datasource;
  }
  updateColor(data: Color): Promise<boolean> {
    return this.dataSource.updateColor(data);
  }
  getColors(): Promise<Color[]> {
        return this.dataSource.getColors();
    }

  createColor(data: Color): Promise<Color[]> {
      return this.dataSource.createColor(data);
  }

  removeColor(id: string): Promise<boolean> {
    return this.dataSource.removeColor(id);
}
    
}